import { useStore } from '@nanostores/react';
import { Button } from '~/components/ui/Button';
import { userStore } from '~/lib/stores/user';

export const PaymentFailBanner = ({ showPricingOverlay }: { showPricingOverlay: VoidFunction }) => {
  const user = useStore(userStore.user);

  if (!user?.featureFlags.teamManagement) {
    return null;
  }

  return (
    <div className="p-4 flex gap-3 bg-bolt-ds-warning-container border border-bolt-ds-borderOutline rounded-md">
      <div>
        <div className="i-ph:warning size-5 text-bolt-ds-warning mt-1" />
      </div>
      <div className="flex flex-col gap-1 items-start">
        <div className="text-bolt-ds-on-warning-container text-base font-semibold">Last Payment Failed</div>
        <div className="text-bolt-ds-textSecondary text-sm">
          We couldn’t process your last payment, as a result, token refills have been paused. Restore your team access
          by managing your payment options.
        </div>
        <Button variant="link-color" color="warning" onClick={showPricingOverlay} className="mt-1">
          Manage billing
        </Button>
      </div>
    </div>
  );
};
